import { Box, Typography } from '@mui/material';
import Surface from './Surface';
import InfoTooltip from '../InfoTooltip';

/**
 * Consolidated stat card used on profile pages, dashboards, etc.
 *
 * tone:
 *   'default'  — white value
 *   'positive' — success green (only when the number is a real positive signal)
 *   'negative' — error red (only when the number is a real negative signal)
 *
 * mono: render the value in the mono font (for numeric data)
 */
export default function StatCard({
    icon: Icon,
    label,
    value,
    tooltip,
    tone = 'default',
    mono = false,
}) {
    const toneColor = {
        default: 'text.primary',
        positive: 'success.main',
        negative: 'error.main',
    }[tone];

    return (
        <Surface padding={2.5} sx={{ height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                {Icon && <Icon sx={{ fontSize: 14, color: 'text.muted' }} />}
                <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                    {label}
                </Typography>
                {tooltip && <InfoTooltip title={tooltip} />}
            </Box>
            <Typography
                sx={{
                    color: toneColor,
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    lineHeight: 1.2,
                    letterSpacing: '-0.02em',
                    fontFamily: theme => (mono ? theme.typography.fontFamilyMono : 'inherit'),
                    fontFeatureSettings: mono ? '"tnum"' : undefined,
                }}
            >
                {value}
            </Typography>
        </Surface>
    );
}
